import { Table } from 'antd';
import {
  Switch,
  Route,
} from "react-router-dom";

import './Content.css';
import Title from '../Title';
import Section from './Section';
import AudioPlayer from '../AudioPlayer';
import * as audioFiles from '../audio';
import tableContent from './tableContent';
import SplitLine from '../SplitLine';
import DemoAPISection from './DemoAPISection';

function SingingVoiceBlock(props) {
  const { singerID } = props;
  return (
    <div className="content__singing-voice-block">
      <p>Singing voice of {singerID}:</p>
      <AudioPlayer src={audioFiles[`MOS_${singerID}`]}/>
    </div>
  );
}

function WrappedTable(props) {
  return (
    <Table
      className="content__table"
      bordered
      pagination={false}
      scroll={{x: 'max-content' }}
      {...props}
    />
  );
}

function DemoContent() {
  return (
    <div>
      <Title />
      <Section title="Abstract">
        <div>
          Singing voice conversion is a well-known task that aims at converting a singer's voice to another one's voice, and recent neural network approaches have greatly improved the quality and application possibility of such technology. This work focuses on an unsupervised, WaveNet-based model, "PitchNet", proposed by Chengqi Deng. We first investigate the properties of the original PitchNet, showing that it has lower conversion quality when performing conversion between females and males as well as unseen source data. Secondly, we proposed three approaches to improve such a model: hyperparameter tuning, pitch augmentation, and two-phase conversion. We conduct our experiments on the NUS-48E dataset. The evaluation is done on the same dataset and a few songs from "The 'Mixing Secrets' Free Multitrack Download Library", using two objective metrics: Pitch Zero-Normalized Cross-Correlation (PZNCC) and Singer Classification Accuracy (SCA), along with a subjective metric: Mean Opinion Score (MOS). The results show that the proposed method can improve pitch accuracy (0.74 vs. 0.81 in PZNCC) and listening quality (2.11 vs. 3.33 in MOS). In addition, the proposed method is more robust against unseen source data (1.48 vs. 3.15 in MOS).
        </div>
      </Section>
      <Section title="Singing Voice Ground Truth">
        <div className="content__gt-voice">
          <SingingVoiceBlock singerID="JTAN"/>
          <SingingVoiceBlock singerID="JLEE"/>
          <SingingVoiceBlock singerID="SAMF"/>
          <SingingVoiceBlock singerID="MPOL"/>
          <SingingVoiceBlock singerID="MPUR"/>
          <SingingVoiceBlock singerID="PMAR"/>
        </div>
      </Section>
      <Section title="Internal Conversion">
        <SingingVoiceBlock singerID="VKOW"/>
        <WrappedTable
          columns={tableContent.demo.internal.columns}
          dataSource={tableContent.demo.internal.dataSources.VKOW}
        />
        <SingingVoiceBlock singerID="ADIZ"/>
        <WrappedTable
          columns={tableContent.demo.internal.columns}
          dataSource={tableContent.demo.internal.dataSources.ADIZ}
        />
      </Section>
      <Section title="External Conversion">
        <SingingVoiceBlock singerID="M1"/>
        <WrappedTable
          columns={tableContent.demo.external.columns}
          dataSource={tableContent.demo.external.dataSources.M1}
        />
        <SingingVoiceBlock singerID="F2"/>
        <WrappedTable
          columns={tableContent.demo.external.columns}
          dataSource={tableContent.demo.external.dataSources.F2}
        />
      </Section>
      <Section title="File Upload">
        <DemoAPISection />
      </Section>
    </div>
  );
}

function MOSContent() {
  return (
    <div>
      <Title />
      <Section title="Singing Voice Ground Truth">
        <div className="content__gt-voice">
          <SingingVoiceBlock singerID="JTAN"/>
          <SingingVoiceBlock singerID="JLEE"/>
          <SingingVoiceBlock singerID="SAMF"/>
          <SingingVoiceBlock singerID="MPOL"/>
          <SingingVoiceBlock singerID="MPUR"/>
          <SingingVoiceBlock singerID="PMAR"/>
        </div>
      </Section>
      <Section title="Audio Samples">
        <SingingVoiceBlock singerID="VKOW"/>
        <WrappedTable
          columns={tableContent.mos.internal.columns}
          dataSource={tableContent.mos.internal.dataSources.VKOW}
          showHeader={false}
        />
        <SplitLine />

        <SingingVoiceBlock singerID="ADIZ"/>
        <WrappedTable
          columns={tableContent.mos.internal.columns}
          dataSource={tableContent.mos.internal.dataSources.ADIZ}
          showHeader={false}
        />
        <SplitLine />

        <SingingVoiceBlock singerID="M1"/>
        <WrappedTable
          columns={tableContent.mos.external.columns}
          dataSource={tableContent.mos.external.dataSources.M1}
          showHeader={false}
        />
        <SplitLine />

        <SingingVoiceBlock singerID="F2"/>
        <WrappedTable
          columns={tableContent.mos.external.columns}
          dataSource={tableContent.mos.external.dataSources.F2}
          showHeader={false}
        />
      </Section>
    </div>
  );
}

function Content() {
  return (
    <div className="content">
      <div className="content__box">
        <Switch>
          <Route path="/mos">
            <MOSContent />
          </Route>
          <Route path="/">
            <DemoContent />
          </Route>
        </Switch>
      </div>
    </div>
  );
}

export default Content;
